<template>
  <div class="market">
    <div class="market-main">
      <div class="market-top">
        <div class="search-wrap">
          <van-search
            class="search"
            v-model="searchValue"
            placeholder="请输入机构名称"
            @clear="onSearch"
          >
          </van-search>
          <div class="search-btn" @click="onSearch">搜索</div>
        </div>
        <div class="market-manual">
          <span>机构列表</span>
          <span @click="onGoMechanism">
            <img src="@/assets/机构@4x.png" alt="" />
            机构入驻</span
          >
        </div>
      </div>

      <van-list
        v-model="loading"
        :finished="upFinished"
        finished-text="没有更多了~"
        @load="onLoad"
        :offset="offset"
        v-if="list && list.length > 0"
      >
        <div class="list-ul">
          <div
            class="list-li"
            v-for="(item, index) in list"
            :key="index"
            @click="details(item.creditCode)"
          >
            <b>{{ item.entName }}</b>
            <span class="list-li-title"
              >交易量：{{ item.dealCount }}
              <span style="margin-left: 10px"
                >发布商品数：{{ item.goods.length || 0 }}</span
              >
            </span>
            <div class="list-li-services">
              <span
                v-for="(text, index) in item.serviceNames"
                :key="text"
                v-if="index < 4"
              >
                {{ text }}
              </span>
              <span v-if="item.serviceNames.length > 4">...</span>
            </div>
            <div class="list-li-list-image">
              <div
                class="list-li-image"
                v-for="(items, f) in item.goods"
                :key="f"
              >
                <img :src="items.url" alt="" />
                <span v-if="items.priceType === 1">面议</span>
                <span v-else>￥{{ items.price || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </van-list>
      <van-empty
        v-else
        class="custom-image"
        :image="require('../../../../assets/coupons-none.png')"
        description="暂无数据"
      />
    </div>
  </div>
</template>
<script>
import { goodsTypeList, entPage, entIntermediaryList } from '@api/market/index'
import { Toast } from 'vant'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { getLocalStorage } from '@utils'
export default {
  components: {},
  data() {
    return {
      status: 0, // 认证状态
      searchValue: '', // 搜索内容
      offset: 100,

      progressShow: true,
      progress: [
        {
          icon: require('../../../../assets/cs-icon1.png'),
          tab: '选择',
          text: '选择商品\n下单'
        },
        {
          icon: require('../../../../assets/cs-icon2.png'),
          tab: '沟通',
          text: '线下和机构\n沟通'
        },
        {
          icon: require('../../../../assets/cs-icon3.png'),
          tab: '确认',
          text: '在线确认\n订单金额'
        },
        {
          icon: require('../../../../assets/cs-icon4.png'),
          tab: '评价',
          text: '评价商品'
        }
      ],
      tabActive: 0,
      tab: [],
      tabId: '',
      list: [],
      listShow: true,
      loading: false,
      upFinished: false,
      pageNum: 0,
      pageSize: 10,
      userInfo: getLocalStorage('lishuiUserInfo')
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {}
    }
  },
  mounted() {
    this.mechanismList()
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    onGoMechanism() {
      this.buriedPoint()
      this.$router.push({
        path: '/intermediary/index'
      })
    },
    // 机构列表
    mechanismList() {
      this.pageNum++
      const params = {
        organizationType: '1',
        keyWord: this.searchValue,
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      entIntermediaryList(params).then(res => {
        const { code, data } = res.data
        if (code === '0000') {
          let lists = data.results || []
          if (lists.length === 0) {
            this.upFinished = true
          } else {
            this.upFinished = false
          }
          for (var i = 0; i < lists.length; i++) {
            this.list.push(lists[i]) // 上拉时循环出来这个数组的三条内容，放入datacontent这个数组里，那样就一直拉一直加
          }
        }
      })
    },
    onSearch() {
      this.list = []
      this.pageNum = 0
      this.mechanismList()
    },
    onLoad() {
      this.loading = false
      this.mechanismList()
    },
    details(e) {
      this.buriedPoint()
      this.$router.push({ name: 'organ', query: { id: e } })
    },
    statusTap() {
      this.$router.push({
        path: '/intermediary/index'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.market {
  width: 100%;
  min-height: calc(100vh - 94px);
  overflow: hidden;
  background: #f7f7f7;
}
.market-main {
  background: #f7f7f7;
  height: calc(100vh - 94px);
  position: relative;
  z-index: 10;
  .market-top {
    width: 100%;
    height: 120px;
    background: url('~@/assets/images/背景@4x.png') no-repeat;
    background-size: 100% 100%;
  }
  .market-manual {
    margin-top: 15px;
    padding: 0 15px;
    font-size: 18px;
    color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    > span:nth-child(2) {
      font-size: 14px;
    }
    img {
      width: 16px;
      vertical-align: middle;
    }
  }
  .search-wrap {
    display: flex;
    align-items: stretch;
    padding: 15px;
    .van-search {
      flex: 1;
      padding: 0;
      box-sizing: border-box;
      background: none;
      .van-search__content {
        background: #fff;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border: none;
      }
    }
    .search-btn {
      font-size: 14px;
      color: #333;
      background: #fff;
      padding: 0 15px;
      display: flex;
      align-items: center;
      margin-left: -4px;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      border-left: 1px solid #eee;
    }
  }
  .tab-wrap {
    padding: 15px 0 0;
  }
}
.list-ul {
  height: calc(100vh - 220px);
  background: #f7f7f7;
  overflow: auto;
  .list-li {
    margin: 10px 10px 0;
    padding: 0 0 11px;
    border-radius: 5px;
    background-color: #fff;
    b {
      font-size: 16px;
      padding: 0 15px;
    }
    &-title {
      display: block;
      margin: 10px 0 0;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.65);
      padding: 0 15px 10px;
      // padding-bottom: 16px;
      // border-bottom: 1px solid #eee;
    }
    &-services {
      padding: 10px 15px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      > span {
        margin: 0 8px 5px 0;
        padding: 5px 10px;
        border: 1px solid rgba(0, 128, 255, 0.65);
        border-radius: 4px;
        font-size: 12px;
        color: #0080ff;
      }
    }
    .list-li-list-image {
      display: flex;
      flex-wrap: wrap;
      padding: 0 15px;
    }
    &-image {
      width: 95px;
      height: 80px;
      position: relative;
      margin: 0 10px 4px 0;

      img {
        width: inherit;
        height: inherit;
      }
      span {
        width: 100%;
        height: 26px;
        line-height: 26px;
        display: inline-block;
        background: rgba(0, 0, 0, 0.3);
        color: #fff;
        text-align: center;
        font-size: 12px;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
    &-image:nth-child(3n) {
      margin-right: 0;
    }
  }
}
.custom-image {
  margin-top: 10%;
  /deep/.van-empty__image {
    width: 200px;
    height: 120px;
  }
  /deep/.van-empty__description {
    margin-top: -36px;
  }
}
/deep/.van-list__finished-text {
  margin-top: 15px;
  height: calc(100% - 124px);
  overflow: auto;
}
</style>
